<!-- RESERVA PUNTUAL -->
<mat-card *ngIf="activeSection === 'reservation'" class="booking-card" (click)="activate('reservation')">
    <mat-card-content>
        <h2>Reserva puntual</h2>

        <form class="text-center">


            <!-- POR FECHAS -->
            <div *ngIf="reservationMode === 'range'" class="section-block">
                <div>
                    <!--
                    <mat-form-field appearance="outline">
                        <mat-label>Inicio</mat-label>
                        <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate"
                            (dateChange)="recalculateReservation()" (focus)="activate('reservation')">
                        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                    </mat-form-field>

                    <div class="arrow">→</div>

                    <mat-form-field appearance="outline">
                        <mat-label>Fin</mat-label>
                        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate"
                            (dateChange)="recalculateReservation()" (focus)="activate('reservation')">
                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endPicker></mat-datepicker>
                    </mat-form-field>
                    
                -->

                    <div class="inline-field">

                        <div class="dp-hidden position-absolute">
                            <div class="input-group">
                                <input name="datepicker" class="form-control d-none" ngbDatepicker
                                    #datepicker="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="1"
                                    [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate" [minDate]="minDate"
                                    [maxDate]="maxDate" tabindex="-1" />
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.disabled]="isMinDate(date) || isMaxDate(date)"
                                        [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)"
                                        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                        <div class="form-inline date-group">
                            <div class="form-group input-group-lg datepickut-wapper m-auto"
                                (click)="modeSelect && datepicker.toggle()">
                                <input #dpFromDate class="form-control input-date" placeholder="dd-mm-yyyy"
                                    name="dpFromDate" [value]="formatDate(fromDate)"
                                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)" />
                            </div>
                            <div class="form-group input-group-lg datepickut-wapper m-auto"
                                (click)="modeSelect && datepicker.toggle()">
                                <input #dpToDate class="form-control input-date" placeholder="dd-mm-yyyy"
                                    name="dpToDate" [value]="formatDate(toDate)"
                                    (input)="toDate = validateInput(toDate, dpToDate.value)" />
                            </div>
                        </div>


                    </div>
                    <div class="inline-field">
                        <div *ngIf="hasTime" class="form-inline date-group">
                            <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeFromTime($event)" class="form-control" name="dpFromTime">
                                    <option *ngFor="let item of fromTimeOptions" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeToTime($event)" class="form-control" name="dpToTime">
                                    <option *ngFor="let item of toTimeOptions" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>


                        <div *ngIf="!modeSelect" class="m-0 p-0 align-self-center">
                            <div class="c-button">
                                <button type="button" (click)="less()" [disabled]="totalPeriod <= totalPeriodInitial"
                                    class="btn btn-primary btn-just-icon"><i
                                        class="nc-icon nc-simple-delete"></i></button>
                                <span></span>
                                <button type="button" (click)="plus()" [disabled]="totalPeriod >= maxPeriod"
                                    class="btn btn-primary btn-just-icon">
                                    <i class="nc-icon nc-simple-add"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>




            </div>

            <!-- POR DURACIÓN -->
            <div *ngIf="reservationMode === 'duration'" class="section-block">
                <div class="duration-box">
                    <div class="duration-header">
                        <span>Inicio</span>
                        <strong>{{ today | date:'d MMM y' }}</strong>
                    </div>

                    <div class="duration-controls">
                        <button type="button" mat-mini-fab color="warn" (click)="decreaseDays(); activate('reservation')">
                            <mat-icon>remove</mat-icon>
                        </button>

                        <div class="duration-value">
                            <div class="big">{{ durationDays }}</div>
                            <div class="small">{{ durationDays === 1 ? 'día' : 'días' }}</div>
                        </div>

                        <button type="button" mat-mini-fab color="warn" (click)="increaseDays(); activate('reservation')">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <div class="duration-footer">
                        <span>Fin automático</span>
                        <strong>{{ computedEndDate | date:'d MMM y' }}</strong>
                    </div>
                </div>
            </div>
        </form>

        <div *ngIf="showDetail" class="summary-box">
            <div class="summary-row">
                <span>Duración</span>
                <strong class="duration">{{ durationLabel }}</strong>
            </div>
            <div class="summary-row">
                <span>{{'offterlocker.total'|traduccion}}</span>
                <strong class="price">{{minPrice | currency}}</strong>
            </div>
            <div class="summary-row">
                <span>{{'offterlocker.from'|traduccion}}</span>
                <strong>{{ fromDateTimeLabel }}</strong>
            </div>
            <div class="summary-row">
                <span>{{'offterlocker.to'|traduccion}}</span>
                <strong>{{ toDateTimeLabel }}</strong>
            </div>
        </div>


    </mat-card-content>
</mat-card>

<!-- SUSCRIPCIÓN -->
<mat-card *ngIf="activeSection === 'subscription'" class="booking-card" (click)="activate('subscription')">
    <mat-card-content>
        <h2>Suscripción</h2>
        <p class="subtitle">Planes recurrentes</p>

        <mat-radio-group *ngFor="let subscription of subscriptions" class="subscription-group" [(ngModel)]="selectedPlan" (click)="onClickSubscription(subscription)">
            <div class="plan-option" [class.selected]="selectedPlan === 'monthly'">
                <mat-radio-button value="monthly">
                    {{subscription.period}} {{subscription.unit|traduccion}}
                </mat-radio-button>
                <strong>{{subscription.amount|currency}}</strong>
            </div>
        </mat-radio-group>

        <div class="subscription-info">
            <div class="info-row ok">
                <mat-icon>check_circle</mat-icon>
                <span>Inicio: <strong>Hoy</strong></span>
            </div>

            <div class="info-row ok light">
                <mat-icon>done</mat-icon>
                <span>Renovación automática</span>
            </div>
        </div>

        <div class="summary-box">
            <div class="summary-row">
                <span>Próximo cobro</span>
                <strong>{{ nextChargeLabel }}</strong>
            </div>
        </div>

    </mat-card-content>
</mat-card>



<!--
<div class="block-date">
    <div class="container p-0">
        <div class="row">
            <div class="col-12 mx-auto d-flex justify-content-center p-0">
                <div class="text-center">
                    <form class="text-center">
                        <div class="dp-hidden position-absolute">
                            <div class="input-group">
                                <input name="datepicker" class="form-control d-none" ngbDatepicker
                                    #datepicker="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="1"
                                    [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate" [minDate]="minDate"
                                    [maxDate]="maxDate" tabindex="-1" />
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.disabled]="isMinDate(date) || isMaxDate(date)"
                                        [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)"
                                        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                        <div class="form-inline date-group">
                            <div class="form-group input-group-lg datepickut-wapper m-auto"
                                (click)="modeSelect && datepicker.toggle()">
                                <input #dpFromDate class="form-control input-date" placeholder="dd-mm-yyyy"
                                    name="dpFromDate" [value]="formatDate(fromDate)"
                                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)" />
                            </div>
                            <div class="form-group input-group-lg datepickut-wapper m-auto"
                                (click)="modeSelect && datepicker.toggle()">
                                <input #dpToDate class="form-control input-date" placeholder="dd-mm-yyyy"
                                    name="dpToDate" [value]="formatDate(toDate)"
                                    (input)="toDate = validateInput(toDate, dpToDate.value)" />
                            </div>
                        </div>

                        <div *ngIf="hasTime" class="form-inline date-group">
                            <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeFromTime($event)" class="form-control" name="dpFromTime">
                                    <option *ngFor="let item of fromTimeOptions" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group input-group-lg datepickut-wapper m-auto">
                                <select (change)="onChangeToTime($event)" class="form-control" name="dpToTime">
                                    <option *ngFor="let item of toTimeOptions" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>


                        <div *ngIf="!modeSelect" class="m-0 p-0 align-self-center">
                            <div class="c-button">
                                <button (click)="less()" [disabled]="getDiffDays() <= 1"
                                    class="btn btn-primary btn-just-icon"><i
                                        class="nc-icon nc-simple-delete"></i></button>
                                <span></span>
                                <button (click)="plus()" [disabled]="getDiffDays() >= MAX_DAYS_FUTURE"
                                    class="btn btn-primary btn-just-icon"><i class="nc-icon nc-simple-add"></i></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div *ngIf="showDetail" class="row">
            <div class="col d-flex justify-content-center">
                <div class="resumen">
                    <h3>{{getDuration()}}</h3>
                    <h5>{{'offterlocker.from'|traduccion}}: <span>{{formatDateWithCurrentTime(fromDate,
                            fromTime)}}</span></h5>
                    <h5>{{'offterlocker.to'|traduccion}}: <span>{{formatDateWithCurrentTime(toDate, toTime)}}</span>
                    </h5>
                    <h5>{{'offterlocker.total'|traduccion}}: <span class="price">{{minPrice}}€</span></h5>
                </div>
            </div>
        </div>
    </div>
</div>
-->
